import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import media from '../../utils/media'
import HelperText from '../form/HelperText'


const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 31%);
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;

  ${media.down('mobile')(css`
    display: block;
  `)}
`

const AnswersContainer = ({helperText, state, children, ...props}) => {
  return (
    <>
      <StyledContainer {...props}>
        {children}
      </StyledContainer>
      <HelperText state={state}>{helperText}</HelperText>
    </>
  )
}

AnswersContainer.propTypes = {
  helperText: PropTypes.string,
  state: PropTypes.string,
  children: PropTypes.array,
}

export default AnswersContainer
